import Collection from './collection.js';
import PayrollItemIntegration from 'newModels/payroll-item-integration.js';

export default class PayrollItemIntegrations extends Collection {
    url() {
        if (this.company) {
            return this.company.url() + '/payrollItemIntegrations';
        }
        return '/payrollItemIntegrations';
    }

    initialize(models, {company = null}) {
        this.model = PayrollItemIntegration;
        super.initialize(...arguments);
        this.company = company;
        return this;
    }

    comparator(model) {
        const weightByType = {
            base: 100,
            mtd: 90,
            epf: 80,
            socso: 70,
            eis: 60,
            zakat: 50,
            hrdf: 40,
            addition: 30,
            benefit: 20,
            deduction: 10
        };
        const weightByAffects = {
            employee: 100,
            mtd: 90,
            epf: 80,
            socso: 70,
            eis: 60,
            zakat: 50,
            hrdf: 40
        };
        const item = model.getPayrollItem();

        if (!item) {
            return -(weightByAffects[model.get('affects')] || 0);
        }

        return -(
            (weightByType[item.get('type')] || 0) -
            (item.get('isNet') ? 5 : 0)
        );
    }

    static fetchForCompany(company, integration, nullItems = false) {
        let where = {
            integrationId: integration.id,
        };

        if (!nullItems) {
            where.payrollItemId = {neq: null};
        }

        return new PayrollItemIntegrations(null, {
                company,
                pagination: false,
                syncRemove: true
            })
            .fetch({filter: {
                where,
                order: '-createdAt',
                limit: 9999
            }});
    }

    static fetchPaymentAccountsForCompany(company, integration) {
        return new PayrollItemIntegrations(null, {
            company
        }).fetch({filter: {
            where: {
                integrationId: integration.id,
                payrollItemId: null,
                affects: {inq: [
                    'employee',
                    'mtd',
                    'socso',
                    'epf',
                    'zakat',
                    'eis',
                    'hrdf'
                ]}
            }
        }});
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/payroll-item-integrations.js